(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aureliane-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aureliane-slideshow')) {
    class AurelianeSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.track || !this.slides.length) return;
        this.current = 0;
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.status = this.querySelector('[data-status]');
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.inView = false;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const controls = this.querySelector('[data-controls]');
        if (controls) controls.hidden = false;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.manual(this.current - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.manual(this.current + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.manual(index), options));
        this.toggle?.addEventListener('pointerdown', () => { this.toggleWasPaused = this.paused; }, options);
        this.toggle?.addEventListener('click', () => {
          this.paused = this.toggleWasPaused === undefined ? !this.paused : !this.toggleWasPaused;
          this.toggleWasPaused = undefined;
          this.renderToggle();
          this.schedule();
        }, options);
        this.addEventListener('focusin', event => { if (event.target.matches(':focus-visible')) this.pause(); }, options);
        this.track.addEventListener('pointerdown', () => { this.targetIndex = null; this.pause(); }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (this.targetIndex != null) {
              if (Math.abs(this.track.scrollLeft - this.targetIndex * this.track.clientWidth) > 2) return;
              this.targetIndex = null;
            }
            const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (index !== this.current && index >= 0 && index < this.slides.length) this.activate(index);
          });
        }, { ...options, passive: true });
        this.addEventListener('keydown', event => {
          if (['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) return;
          let destination;
          if (event.key === 'ArrowRight') destination = this.current + 1;
          if (event.key === 'ArrowLeft') destination = this.current - 1;
          if (event.key === 'Home') destination = 0;
          if (event.key === 'End') destination = this.slides.length - 1;
          if (destination === undefined) return;
          event.preventDefault();
          this.pause();
          this.manual(destination);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index !== -1) { this.pause(); this.manual(index, 'instant'); }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'instant' });
        });
        this.resizeObserver.observe(this.track);
        this.activate(0);
        this.renderToggle();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.abortController?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
      pause() {
        this.paused = true;
        this.renderToggle();
        this.schedule();
      }
      renderToggle() {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
      }
      manual(index, behavior) {
        this.show(index, behavior);
        this.schedule();
        if (this.status) this.status.textContent = this.slides[this.current].getAttribute('aria-label');
      }
      show(index, behavior) {
        const target = (index + this.slides.length) % this.slides.length;
        this.targetIndex = target;
        this.activate(target);
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: behavior || (this.motion.matches ? 'instant' : 'smooth') });
      }
      activate(index) {
        this.current = index;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, position) => {
          if (position === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || !this.inView || document.hidden || this.motion.matches || this.slides.length < 2) return;
        this.timer = setTimeout(() => {
          this.show(this.current + 1);
          this.schedule();
        }, Math.max(5000, Number(this.dataset.interval) || 7000));
      }
    }
    customElements.define('aureliane-slideshow', AurelianeSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
